import { Shuffle } from 'lucide-react'

import type { LibraryAlbum } from '@/api/types'
import { CollectionCard } from '@/components/CollectionCard'
import { Cover } from '@/components/Cover'
import { Skeleton } from '@/components/ui'

import { trackCountLabel } from './labels'

export interface LibraryAlbumCardProps {
  album: LibraryAlbum
  onOpen: (album: LibraryAlbum) => void
}

/** Artist and year, or an explanation for the Singles bucket. */
export function albumSubtitle(album: LibraryAlbum): string {
  if (album.is_singles) return 'Songs that are not part of an album'
  return album.release_year ? `${album.artist_name} · ${album.release_year}` : album.artist_name
}

/** "8 of 11 songs" once we know the album is longer than what is owned. */
export function albumCountLabel(album: LibraryAlbum): string {
  const partial =
    !album.is_singles && album.total_tracks !== null && album.total_tracks > album.track_count
  return partial ? `${album.track_count} of ${album.total_tracks} songs` : trackCountLabel(album.track_count)
}

export function LibraryAlbumCard({ album, onOpen }: LibraryAlbumCardProps) {
  return (
    <li>
      <CollectionCard onClick={() => onOpen(album)} title={album.title}
        subtitle={album.is_singles ? 'Songs without an album' : album.artist_name}
        metadata={[album.release_year, albumCountLabel(album)].filter(Boolean).join(' · ')}
        artwork={album.is_singles ? <span className="flex aspect-square w-full items-center justify-center rounded-card border border-dashed border-border-strong bg-surface-raised"><Shuffle className="h-8 w-8 text-text-subtle" aria-hidden="true" /></span> : <Cover src={album.cover_url} size="xl" />} />
    </li>
  )
}

export function LibraryAlbumCardSkeleton() {
  return (
    <li className="p-2">
      <Skeleton className="aspect-square w-full rounded-card" />
      <Skeleton className="mt-3 h-3.5 w-3/4" />
      <Skeleton className="mt-2 h-3 w-1/2" />
      <Skeleton className="mt-2 h-3 w-1/3" />
    </li>
  )
}
